import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "menu-categories-component",
  class: "text-white fs-6"
}
const _hoisted_2 = { class: "row ms-0" }
const _hoisted_3 = { class: "col-12 red-color text-center fs-5" }
const _hoisted_4 = { class: "row ms-0" }
const _hoisted_5 = {
  class: "col-11 offset-1 border pt-2",
  id: "categories-container"
}
const _hoisted_6 = { class: "ps-0" }
const _hoisted_7 = {
  key: 0,
  class: "container-accordion"
}
const _hoisted_8 = ["data-bs-target", "aria-controls", "onClick"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.languageStore.text(_ctx.TEXT_KEYS.CATEGORY_TITLE)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              (item.sub_categories.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "border-0 bg-transparent text-white ps-0 fw-light fs-5",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": '#category-' + item.id,
                      "aria-controls": 'category-' + item.id,
                      onClick: ($event: any) => (_ctx.onCategoryClicked(item.id))
                    }, _toDisplayString(item.title_fr), 9, _hoisted_8),
                    _createElementVNode("ul", {
                      id: 'category-' + item.id,
                      class: "accordion-collapse collapse"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub_categories, (sub_category) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: sub_category.id,
                          class: "subcategories fs-5",
                          onClick: ($event: any) => (_ctx.onSubCategoryClicked(item.id, sub_category.id))
                        }, _toDisplayString(sub_category.title_fr), 9, _hoisted_10))
                      }), 128))
                    ], 8, _hoisted_9)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "category-no-subcategories fs-5",
                    onClick: ($event: any) => (_ctx.onCategoryClicked(item.id))
                  }, _toDisplayString(item.title_fr), 9, _hoisted_11))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}